/**
 * @author       kevin.chau@zumper.com (Kevin Chau)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  trackFloorplanView.js
 */

import { getUser } from '@zcode-ui/web-zumper-global-state'
import Marketing from '@zcode/nr/es/shared/utils/marketing'
import type { GetState } from '@zcode/state-type'
import type { Dispatch } from 'redux'

const trackFloorplanView = (listingId: number) => (dispatch: Dispatch, getState: GetState) => {
  const state = getState()
  const user = getUser(state)

  if (listingId !== undefined) {
    Marketing.trackViewDetail(undefined, listingId, user.email)
  }
}

export default trackFloorplanView
